var exports = {
  "SF": "sectionHeading__4n11uG",
  "GO": "headingLinkWrapper__p09IkX",
  "Fc": "headingLink__JrGf-v",
  "uI": "moreLink__jeEcgs",
  "om": "sidebarSection__oqw6Y8",
};

module.exports = exports;
